import actions from './actions';
import types from './mutation-types';

const state = {
	bids: {
		error: null,
		isFetching: false,
		data: [],
		meta: {
			currentPage: 1,
			totalItems: null,
			totalPages: null
		}
	},
	delete: {
		isDeleting: false,
		error: null
	},
	bid: {}
};

const getters = {
	bidsIsFetching: state => state.bids.isFetching,
	isDeleting: state => state.delete.isDeleting,
	bids: state => state.bids
};

const mutations = {
	[types.FETCH_BIDS_START](state) {
		state.bids.isFetching = true;
	},
	[types.FETCH_BIDS_ERROR](state, error) {
		state.bids.isFetching = false;
		state.bids.error = error;
	},
	[types.FETCH_BIDS_SUCCESS](state, data) {
		state.bids.isFetching = false;
		state.bids.error = null;
		state.bids.data = data.bids;
		state.bids.meta = data.meta;
	},
	[types.DELETE_BID_START](state) {
		state.delete.isDeleting = true;
		state.delete.error = null;
	},
	[types.DELETE_BID_SUCCESS](state) {
		state.delete.isDeleting = false;
		state.bid = {};
	},
	[types.DELETE_BID_ERROR](state, payload) {
		state.delete.isDeleting = false;
		state.delete.error = payload;
	}
};

export default {
	namespaced: true,
	state,
	actions,
	getters,
	mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/bid-list/index.js